/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 */
import React from 'react';
import { Modal } from '../../../shared/modals/Modal';
import { View } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { ModalStatePanel } from '../../../shared/modals/ModalStatePanel'
import { OperationalConfirmModal } from '../../../shared/modals/OperationalConfirmModal'
import { modalExperience } from '../../../shared/modals/modalExperience.styles';

export type CatalogMasterConfirmSpec =
  | {
      kind: 'confirm';
      title: string;
      message: string;
      entityName?: string;
      confirmLabel: string;
      destructive?: boolean;
      loading?: boolean;
      iconName?: keyof typeof Ionicons.glyphMap;
      onConfirm: () => void | Promise<void>;
    }
  | {
      kind: 'info';
      title: string;
      message: string;
      entityName?: string;
    }
  | {
      kind: 'loading';
      message: string;
    };

type Props = {
  spec: CatalogMasterConfirmSpec | null;
  onClose: () => void;
};

export function CatalogMasterConfirmModal({ spec, onClose }: Props) {
  if (!spec) return null;

  if (spec.kind === 'loading') {
    return (
      <Modal visible transparent animationType="fade" onRequestClose={onClose}>
        <View style={modalExperience.pickerBackdrop}>
          <View style={[modalExperience.pickerCard, { maxWidth: 360, alignItems: 'stretch' }]}>
            <ModalStatePanel loading loadingMessage={spec.message} />
          </View>
        </View>
      </Modal>
    );
  }

  if (spec.kind === 'info') {
    return (
      <OperationalConfirmModal
        visible
        title={spec.title}
        entityName={spec.entityName}
        message={spec.message}
        confirmLabel="Entendido"
        iconName="information-circle-outline"
        onClose={onClose}
        onConfirm={onClose}
      />
    );
  }

  return (
    <OperationalConfirmModal
      visible
      title={spec.title}
      entityName={spec.entityName}
      message={spec.message}
      confirmLabel={spec.confirmLabel}
      loading={spec.loading}
      destructive={spec.destructive}
      iconName={spec.iconName}
      onClose={onClose}
      onConfirm={spec.onConfirm}
    />
  );
}
